import { render, staticRenderFns } from "./TileProductThroughputPerSecond.vue?vue&type=template&id=1139146e"
import script from "./TileProductThroughputPerSecond.vue?vue&type=script&lang=js"
export * from "./TileProductThroughputPerSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports